/**
 * نصوص بلوكَي الهوم ٧ (اقتباس نمرو) و٨ (نشرة البريد).
 * تُخزَّن في app_settings تحت key="home_texts".
 */
import { createServerFn } from "@tanstack/react-start";
import { z } from "zod";
import { requireSupabaseAuth } from "@/integrations/supabase/auth-middleware";
import { assertAdmin } from "./adminAuth.server";
import { HOME_TEXTS_KEY, normalizeHomeTexts } from "./homeTexts.server";

export type HomeTexts = {
  quoteEnabled: boolean;
  quoteAr: string;
  quoteEn: string;
  quoteAuthor: string;
  newsletterEnabled: boolean;
  nlEyebrowAr: string;
  nlEyebrowEn: string;
  nlTitleAr: string;
  nlTitleEn: string;
  nlBodyAr: string;
  nlBodyEn: string;
};

export const getHomeTexts = createServerFn({ method: "GET" })
  .inputValidator((d: unknown) =>
    z.object({}).parse(d ?? {}),
  )
  .handler(async ({ data: input }) => {
  const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
  const { data } = await supabaseAdmin
    .from("app_settings")
    .select("value")
    .eq("key", HOME_TEXTS_KEY)
    .maybeSingle();
  return { texts: normalizeHomeTexts(data?.value ?? null) };
});

export const setHomeTexts = createServerFn({ method: "POST" })
  .middleware([requireSupabaseAuth])
  .inputValidator((d: unknown) =>
    z
      .object({
        quoteEnabled: z.boolean(),
        quoteAr: z.string().max(400),
        quoteEn: z.string().max(400),
        quoteAuthor: z.string().max(80),
        newsletterEnabled: z.boolean(),
        nlEyebrowAr: z.string().max(120),
        nlEyebrowEn: z.string().max(120),
        nlTitleAr: z.string().max(200),
        nlTitleEn: z.string().max(200),
        nlBodyAr: z.string().max(400),
        nlBodyEn: z.string().max(400),
      })
      .parse(d),
  )
  .handler(async ({ data, context }) => {
    await assertAdmin(context.userId);
    const { supabaseAdmin } = await import("@/integrations/supabase/client.server");
    const value = normalizeHomeTexts(data);
    const { error } = await supabaseAdmin.from("app_settings").upsert(
      {
        key: HOME_TEXTS_KEY,
        value,
        updated_by: context.userId,
        updated_at: new Date().toISOString(),
      },
      { onConflict: "key" },
    );
    if (error) throw new Error(error.message);
    return { ok: true, texts: value };
  });
